module.exports = __webpack_public_path__ + "img/4.89e51520.jpg";